/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { PromoToken } from './PromoToken';
import {
    PromoTokenFromJSON,
    PromoTokenFromJSONTyped,
    PromoTokenToJSON,
    PromoTokenToJSONTyped,
} from './PromoToken';

/**
 * 
 * @export
 * @interface GetPromoTokensResponse
 */
export interface GetPromoTokensResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetPromoTokensResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<PromoToken>}
     * @memberof GetPromoTokensResponse
     */
    promoTokens: Array<PromoToken>;
}

/**
 * Check if a given object implements the GetPromoTokensResponse interface.
 */
export function instanceOfGetPromoTokensResponse(value: object): value is GetPromoTokensResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('promoTokens' in value) || value['promoTokens'] === undefined) return false;
    return true;
}

export function GetPromoTokensResponseFromJSON(json: any): GetPromoTokensResponse {
    return GetPromoTokensResponseFromJSONTyped(json, false);
}

export function GetPromoTokensResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromoTokensResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'promoTokens': ((json['promoTokens'] as Array<any>).map(PromoTokenFromJSON)),
    };
}

export function GetPromoTokensResponseToJSON(json: any): GetPromoTokensResponse {
    return GetPromoTokensResponseToJSONTyped(json, false);
}

export function GetPromoTokensResponseToJSONTyped(value?: GetPromoTokensResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'promoTokens': ((value['promoTokens'] as Array<any>).map(PromoTokenToJSON)),
    };
}

